import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Sunrise, Sun, Sunset } from 'lucide-react';
const phases = [{
  name: 'Menstrual',
  icon: Moon,
  color: 'bg-purple-100 text-purple-600'
}, {
  name: 'Folicular',
  icon: Sunrise,
  color: 'bg-green-100 text-green-600'
}, {
  name: 'Ovulatoria',
  icon: Sun,
  color: 'bg-yellow-100 text-yellow-600'
}, {
  name: 'Lútea',
  icon: Sunset,
  color: 'bg-orange-100 text-orange-600'
}];
export function NewMechanismSection() {
  return <section className="w-full bg-bg-alt py-16 md:py-24 px-4" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-8" data-id="element-48">
          Tu ciclo no es solo tu menstruación
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-xl text-text-secondary text-center leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-49">
          Es un sistema completo que influye en tu energía, tus emociones, tu
          concentración y tus decisiones. Cada semana de tu ciclo es diferente —
          y cuando aprendes a reconocer cada fase, dejas de luchar contigo misma
          y empiezas a trabajar a tu favor.
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-50">
          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/70 rounded-2xl p-6 text-center space-y-3" data-id="element-51">
              <div className={`w-16 h-16 mx-auto rounded-full ${phase.color} flex items-center justify-center`} data-id="element-52">
                <phase.icon className="w-8 h-8" strokeWidth={1.5} data-id="element-53" />
              </div>
              <p className="font-medium text-text-primary" data-id="element-54">{phase.name}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}